
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reviews/[make]/page/[page]",
      function () {
        return require("private-next-pages/reviews/[make]/page/[page].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reviews/[make]/page/[page]"])
      });
    }
  